import { render, staticRenderFns } from "./product-asset-group-category-form.vue?vue&type=template&id=35ea1fb4"
import script from "./product-asset-group-category-form.vue?vue&type=script&lang=js"
export * from "./product-asset-group-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports